import React from "react";
import { Box, Typography } from "@mui/material";
import forbiddenImage from "assets/images/403.png";

export const NotAuthorized = () => {
  return (
    <Box sx={{ height: "60vh", py: 8, textAlign: "center" }}>
      <img src={forbiddenImage} alt="Forbidden" />
      {/* <Typography variant="h6" component="h1">403 Forbidden</Typography> */}
      <Typography variant="subtitle1">
        Access denied. You do not have the necessary permissions to view or
        interact with this content. If you believe this is an error, please
        contact our support team for assistance.
      </Typography>
    </Box>
  );
};
